module.exports = __webpack_public_path__ + "static/06-3faa2bf14ab949fa8123ffa447920e83.jpg";